import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 items-start gap-2 sm:grid-cols-2 lg:grid-cols-4" }

import LogFilter from '@/components/log/LogFilter.vue';
    import { useQuery } from '@tanstack/vue-query';
    import axios from 'axios';
    import { useLogStore } from '@/stores/log';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LogFilters',
  setup(__props) {

    const logStore = useLogStore();

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.ACTIVITIES],
        queryFn: getActivities,
        placeholderData: {
            by: [],
            description: [],
            action: [],
            for: [],
        },
    });

    async function getActivities() {
        const { data } = await axios.get(route('v2.log.activities'), {
            params: {
                fromDate: logStore.startDate.toString(),
                toDate: logStore.endDate.toString(),
                selectedRows: logStore.selectedRows,
            },
        });
        return data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logStore).filters, (filter) => {
      return (_openBlock(), _createBlock(LogFilter, {
        name: filter.name,
        label: filter.label,
        data: _unref(data)[filter.name] || [],
        loading: _unref(isFetching)
      }, null, 8, ["name", "label", "data", "loading"]))
    }), 256))
  ]))
}
}

})